import { gql } from '@apollo/client';

export interface QaPreviewReportJob extends reports.ReportJob {
  id: number;
  reportStatus: string;
  mapOnly: boolean | null;
  workspaceId: number;
  requestedThrough: string;
  noOfProjectsAddedTo: number;
  params: Record<string, unknown> | null;
  producerByWorkspaceId: { id: number; name: string } | null;
}

export interface QaPreviewReportResponse {
  reports: { nodes: QaPreviewReportJob[] };
}

export default gql`
  query QaPreviewReport($reportId: UUID!) {
    reports: allReportJobs(condition: { reportId: $reportId }, first: 1) {
      nodes {
        id
        jobId
        parentJobId
        reportId
        projectName
        reportType
        targetGroupName
        requestedThrough
        startedAt
        reportStatus
        pdfEfsUri
        clientName
        passedQa
        mapOnly
        workspaceId
        params
        noOfProjectsAddedTo
        producerByWorkspaceId {
          id
          name
        }
        reportSummaries: reportSummariesByReportId {
          nodes {
            version
            productByProductId {
              id
              name
            }
          }
        }
      }
    }
  }
`;
